import React from 'react';
import { Link } from 'react-router-dom';
import { MailIcon, PhoneIcon, MapPinIcon, FacebookIcon, InstagramIcon, TwitterIcon, YoutubeIcon } from 'lucide-react';
import { Input } from '../ui/Input';
import { Button } from '../ui/Button';
export function Footer() {
  return <footer className="bg-gray-900 text-gray-300" data-id="element-274" data-mp="ao043s9el46x">
      {/* Newsletter section */}
      <div className="bg-primary-600" data-id="element-275" data-mp="5p6qlzu49d6r">
        <div className="max-w-7xl mx-auto px-4 py-8" data-id="element-276" data-mp="oj51tonpojx">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4" data-id="element-277" data-mp="q2izdmubnij">
            <div data-id="element-278" data-mp="3s1cbhs427o7s">
              <h3 className="text-xl font-bold text-white" data-id="element-279" data-mp="3s0u7uaf2i7pu">
                Subscribe to our Newsletter
              </h3>
              <p className="text-primary-100" data-id="element-280" data-mp="3j28t6qcpvcuc">
                Get the latest deals and updates delivered to your inbox
              </p>
            </div>
            <div className="flex w-full md:w-auto gap-2" data-id="element-281" data-mp="3e249yskfc40f">
              <Input type="email" placeholder="Enter your email" className="bg-white/10 border-white/20 text-white placeholder:text-white/60 w-full md:w-80" data-id="element-282" data-mp="393j7snlm3a9c" />
              <Button variant="secondary" className="whitespace-nowrap" data-id="element-283" data-mp="2kba19dmwtm76">
                Subscribe
              </Button>
            </div>
          </div>
        </div>
      </div>

      {/* Main footer */}
      <div className="max-w-7xl mx-auto px-4 py-12" data-id="element-284" data-mp="2balosnd5ztwe">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-285" data-mp="2gcb106c4idm2">
          {/* Company info */}
          <div data-id="element-286" data-mp="341lr8tvukply">
            <div className="flex items-center gap-2 mb-4" data-id="element-287" data-mp="33yzjou8yia3q">
              <img src="https://cdn.magicpatterns.com/uploads/fRsBpVfPoCHsQawYgHjccg/ChatGPT_Image_Mar_6,_2026,_03_48_02_AM.png" alt="Gadgets Zone" className="h-10 w-auto object-contain bg-white rounded p-1" data-id="element-288" data-mp="381nwte4pe36i" />
              <div data-id="element-289" data-mp="2z0pmyf7l31g0">
                <h2 className="text-lg font-bold text-white" data-id="element-290" data-mp="2z069baoyuz7s">Gadgets Zone</h2>
              </div>
            </div>
            <p className="text-sm mb-4" data-id="element-291" data-mp="1iq3w0vbwqj96">
              Your one-stop shop for affordable gadgets and electronics. Quality
              products at the best prices in Pakistan.
            </p>
            <div className="space-y-2 text-sm" data-id="element-292" data-mp="13mtz5zjxmt0g">
              <div className="flex items-center gap-2" data-id="element-293" data-mp="ziw2dvi2xuak">
                <MapPinIcon className="w-4 h-4 text-primary-400" data-id="element-294" data-mp="zli9xv4z09ss" />
                <span data-id="element-295" data-mp="uqusuhcaqho8">Karachi, Pakistan</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-296" data-mp="ptuku0vvz4uh">
                <PhoneIcon className="w-4 h-4 text-primary-400" data-id="element-297" data-mp="pr8gea4al5gh" />
                <span data-id="element-298" data-mp="kv16y7cotbts">+92-313-2370605</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-299" data-mp="fveyeb7t0jrb">
                <MailIcon className="w-4 h-4 text-primary-400" data-id="element-300" data-mp="ftu14du3umpr" />
                <span data-id="element-301" data-mp="bul85b6w2sv9">waqas.nizam@paysyslabs.com</span>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div data-id="element-302" data-mp="6wjp2q9gqtjs">
            <h3 className="text-white font-semibold mb-4" data-id="element-303" data-mp="6wtdi9ev0snd">Quick Links</h3>
            <ul className="space-y-2 text-sm" data-id="element-304" data-mp="266t8j41zc1yf">
              <li data-id="element-305" data-mp="217ygrcm1b326">
                <Link to="/products" className="hover:text-primary-400 transition-colors" data-id="element-306" data-mp="219jaj00iyhyz">
                  All Products
                </Link>
              </li>
              <li data-id="element-307" data-mp="2dr3td2veyp5q">
                <Link to="/products?deals=true" className="hover:text-primary-400 transition-colors" data-id="element-308" data-mp="2dqkejv128gvx">
                  Deals & Offers
                </Link>
              </li>
              <li data-id="element-309" data-mp="2ngx3s0jtky8e">
                <Link to="/products?new=true" className="hover:text-primary-400 transition-colors" data-id="element-310" data-mp="2nhexoqj0f0d5">
                  New Arrivals
                </Link>
              </li>
              <li data-id="element-311" data-mp="1pvhip33u9d5y">
                <Link to="/products?bestseller=true" className="hover:text-primary-400 transition-colors" data-id="element-312" data-mp="1urpvwayh6wah">
                  Best Sellers
                </Link>
              </li>
              <li data-id="element-313" data-mp="23sxtsrx2xv41">
                <Link to="/about" className="hover:text-primary-400 transition-colors" data-id="element-314" data-mp="23tfm5dgmfp6o">
                  About Us
                </Link>
              </li>
              <li data-id="element-315" data-mp="3b67v6rfa5g9v">
                <Link to="/contact" className="hover:text-primary-400 transition-colors" data-id="element-316" data-mp="3b8u7t5h12lyy">
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>

          {/* Customer Service */}
          <div data-id="element-317" data-mp="38sch8hi7fdgj">
            <h3 className="text-white font-semibold mb-4" data-id="element-318" data-mp="38sw143rf0bx7">Customer Service</h3>
            <ul className="space-y-2 text-sm" data-id="element-319" data-mp="3npmt3ryrelcs">
              <li data-id="element-320" data-mp="3nqeq97808r56">
                <Link to="/account" className="hover:text-primary-400 transition-colors" data-id="element-321" data-mp="3nmqvk4qtpyov">
                  My Account
                </Link>
              </li>
              <li data-id="element-322" data-mp="j2tctgwjj48">
                <Link to="/account/orders" className="hover:text-primary-400 transition-colors" data-id="element-323" data-mp="ikt7lr4ckr1">
                  Order History
                </Link>
              </li>
              <li data-id="element-324" data-mp="a95p31ferb69">
                <Link to="/track-order" className="hover:text-primary-400 transition-colors" data-id="element-325" data-mp="a9nno4pjm1hc">
                  Track Order
                </Link>
              </li>
              <li data-id="element-326" data-mp="ja3u9n1l1oqf">
                <Link to="/wishlist" className="hover:text-primary-400 transition-colors" data-id="element-327" data-mp="jboo1ag2p3n8">
                  Wishlist
                </Link>
              </li>
              <li data-id="element-328" data-mp="xxu41r510kdh">
                <Link to="/faq" className="hover:text-primary-400 transition-colors" data-id="element-329" data-mp="xxc9cyy0ie7o">
                  FAQ
                </Link>
              </li>
            </ul>
          </div>

          {/* Policies */}
          <div data-id="element-330" data-mp="ovuluvi9za8y">
            <h3 className="text-white font-semibold mb-4" data-id="element-331" data-mp="owe124gjjkja">Policies</h3>
            <ul className="space-y-2 text-sm" data-id="element-332" data-mp="tv7gw3javnmm">
              <li data-id="element-333" data-mp="ty3e1pnbq8a0">
                <Link to="/privacy-policy" className="hover:text-primary-400 transition-colors" data-id="element-334" data-mp="f72xexcfb82s">
                  Privacy Policy
                </Link>
              </li>
              <li data-id="element-335" data-mp="jz47qdq16oq6">
                <Link to="/terms" className="hover:text-primary-400 transition-colors" data-id="element-336" data-mp="jznkzh4qkoxv">
                  Terms & Conditions
                </Link>
              </li>
              <li data-id="element-337" data-mp="a8j6sjmvx843">
                <Link to="/return-policy" className="hover:text-primary-400 transition-colors" data-id="element-338" data-mp="a5x4ayeupisq">
                  Return & Refund Policy
                </Link>
              </li>
              <li data-id="element-339" data-mp="16s6xvf0zvi5">
                <Link to="/shipping-policy" className="hover:text-primary-400 transition-colors" data-id="element-340" data-mp="19e8nef8jgsg">
                  Shipping Policy
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Social links & payment methods */}
        <div className="mt-12 pt-8 border-t border-gray-800" data-id="element-341" data-mp="1u4yrstcvtfmz">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4" data-id="element-342" data-mp="1p5cfcm4vo3f8">
            <div className="flex items-center gap-4" data-id="element-343" data-mp="2lvd3cixfafvh">
              <span className="text-sm" data-id="element-344" data-mp="2lutiouge1ddr">Follow us:</span>
              <div className="flex items-center gap-3" data-id="element-345" data-mp="2ht89pk6z5j8u">
                <a href="#" className="w-8 h-8 bg-gray-800 rounded-full flex items-center justify-center hover:bg-primary-600 transition-colors" aria-label="Facebook" data-id="element-346" data-mp="2hrndzr8xbu9e">
                  <FacebookIcon className="w-4 h-4" data-id="element-347" data-mp="27usgnbodzzwp" />
                </a>
                <a href="#" className="w-8 h-8 bg-gray-800 rounded-full flex items-center justify-center hover:bg-primary-600 transition-colors" aria-label="Instagram" data-id="element-348" data-mp="11g1bgvs8dswv">
                  <InstagramIcon className="w-4 h-4" data-id="element-349" data-mp="wirmfh8r7j9k" />
                </a>
                <a href="#" className="w-8 h-8 bg-gray-800 rounded-full flex items-center justify-center hover:bg-primary-600 transition-colors" aria-label="Twitter" data-id="element-350" data-mp="meb9owqkmi9z">
                  <TwitterIcon className="w-4 h-4" data-id="element-351" data-mp="waed05x5smyi" />
                </a>
                <a href="#" className="w-8 h-8 bg-gray-800 rounded-full flex items-center justify-center hover:bg-primary-600 transition-colors" aria-label="YouTube" data-id="element-352" data-mp="1114fnbe7abpi">
                  <YoutubeIcon className="w-4 h-4" data-id="element-353" data-mp="1552f5n7ftoj3" />
                </a>
              </div>
            </div>
            <div className="flex items-center gap-4" data-id="element-354" data-mp="1a3vttiygnlku">
              <span className="text-sm" data-id="element-355" data-mp="1f274fvwky044">We accept:</span>
              <div className="flex items-center gap-2" data-id="element-356" data-mp="1k08ke7ypljbd">
                <div className="bg-white rounded px-2 py-1 text-xs font-bold text-gray-900" data-id="element-357" data-mp="1jzqhishjk6uh">
                  VISA
                </div>
                <div className="bg-white rounded px-2 py-1 text-xs font-bold text-gray-900" data-id="element-358" data-mp="3lrlowvwrlp6w">
                  MC
                </div>
                <div className="bg-white rounded px-2 py-1 text-xs font-bold text-green-600" data-id="element-359" data-mp="1riztmthfmjn8">
                  JazzCash
                </div>
                <div className="bg-white rounded px-2 py-1 text-xs font-bold text-blue-600" data-id="element-360" data-mp="1mikfw0t8na4q">
                  EasyPaisa
                </div>
                <div className="bg-gray-700 rounded px-2 py-1 text-xs font-bold text-white" data-id="element-361" data-mp="1w9yb3we5pns2">
                  COD
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Copyright */}
      <div className="bg-gray-950 py-4" data-id="element-362" data-mp="13ndjqvxolboi">
        <div className="max-w-7xl mx-auto px-4 text-center text-sm" data-id="element-363" data-mp="1hllmxllb9984">
          <p data-id="element-364" data-mp="1hmwmtabmxwty">© 2024 Gadgets Zone. All rights reserved.</p>
        </div>
      </div>
    </footer>;
}